<!-- eslint-disable -->
<template lang="pug">
    .examples-viewer
        .examples-viewer__examples
            .example(v-for="(example, index) in examplesArray")
                .example__container(:style="exampleStyle(index)")
                    .example__title
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_example') }} {{ index + 1 }}
                    .example__actions
                        span.example__action {{ getLeftNumber(example) }}
                        span.example__action {{ example.operation }}
                        span.example__action {{ getRightNumber(example) }}
                    .example__answer
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}: {{ getAnswer(example) }}
                    .example__answer(v-if="isRemainderOn")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_remainder') }}: {{ getRemainder(example) }}
        .examples-viewer__button
            cs-button(
                color="blue"
                @click="$router.push({name: 'dashboard'})"
            )
                | {{ $i18n.t('common.common_navigation_goToMain') }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            examplesArray: Array,
            fractionalPart: Object,
            fractions: Object,
            numbers: Boolean,
            isRemainderOn: Boolean
        },
        data () {
            return {
                colors: [
                    'hsl(121, 58%, 58%)', 'hsl(212, 100%, 56%)', 'hsl(15, 100%, 64%)', 'hsl(38, 100%, 56%)',
                    'hsl(331, 100%, 68%)', 'hsl(158, 62%, 54%)', 'hsl(284, 59%, 64%)', 'hsl(195, 86%, 64%)'
                ]
            }
        },
        methods: {
            getLeftNumber(example) {
                return this.fractions && this.fractions.left && !(this.numbers && example.operation === '*')
                    ? Math.abs(example.left).toFixed(this.fractionalPart.left)
                    : Math.abs(example.left);
            },
            getRightNumber(example) {
                return this.fractions && this.fractions.right && !(this.numbers && example.operation === '/')
                    ? Math.abs(example.right).toFixed(this.fractionalPart.right)
                    : Math.abs(example.right);
            },
            getRemainder(example) {
              return (example.left % example.right);
            },
            getAnswer(example) {
                if (this.isRemainderOn) {
                     return (example.left / example.right) >> 0
                } else {
                    let precision = 0;
                    if (this.fractions && this.fractions.left) {
                        precision += +this.fractionalPart.left;
                    }
                    if (this.fractions && this.fractions.right) {
                        precision += +this.fractionalPart.right;
                    }
                    return example.operation === '/'
                        ? +(example.left / example.right).toFixed(precision)
                        : +(example.left * example.right).toFixed(precision);
                }
            },
            exampleStyle(index) {
                return { color: this.colors[index % this.colors.length] };
            }
        }
    }
</script>

<style lang="scss" scoped>
    .examples-viewer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .examples-viewer__examples {
        display: flex;
        margin: -10px -10px 0;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        font-size: $font-size-24;
    }

    .example {
        padding: 10px;
    }

    .example__action:nth-child(2n) {
        filter: hue-rotate(10deg) saturate(50%);
    }

    .example__container {
        background-color: $x-color-white;
        padding: 10px;
        border: 1px solid;
        border-radius: $border-radius-10;
    }

    .example__title, .example__answer {
        @include stack-space($space-x-small);
    }

    .examples-viewer__button {
        margin-top: 20px;
    }
</style>
